import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9ysabjm1c7: FaireBrandEntity = {
  token: "b_9ysabjm1c7",
  type: "brand",
  name: "Lux Leonis",
  avatarUrl:
    "https://cdn.faire.com/fastly/64bc9f6a8bfe28c34c84f2816e5a4e69614682e0313f6dbf92d4ff7a0094ee05.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ef6afd02a04092764422b585733cbd5890ad5a7826fc3d927e41691fe594f0d5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/64bc9f6a8bfe28c34c84f2816e5a4e69614682e0313f6dbf92d4ff7a0094ee05.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ef6afd02a04092764422b585733cbd5890ad5a7826fc3d927e41691fe594f0d5.jpeg",
  location: "Byron, GA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "We are a modern skin care company with traditional roots and a keen eye to the future. Lux Leonis is devoted to formulating products with exotic and farm-fresh ingredients that provide customers with the upscale, luxurious experience we wholeheartedly believe they deserve. Founded by a college professor, mother of twins, former National Champion in tennis, world traveler and nature lover whose vision is to provide products of superior quality of products made with natural ingredients and backed by science.  Lux Leonis seeks to positively contribute to society and the environment by sourcing ingredients locally where possible, offering educational opportunities to students, and supporting small business owners locally and across the world. We are a company where everything is handmade from scratch so our customers can truly experience a one-of-a-kind product that is unique to them and them alone.\nIn our fast-paced society, it can be easy to forget about taking time to recharge. Experience spa treatment like never before in the comfort of your own home. Treat your skin, body, and mind to our products for a nourishing,  comforting and one of a kind experience that only Lux Leonis can offer. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:10.138Z",
    importedBy: "entity-db-cli",
  },
};
